import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection, FeatureCard } from '../../components/footer/ContentSection';
import { CTASection } from '../../components/footer/CTASection';

export const BackgroundCheckPage: React.FC = () => {
  const theme = useTheme();

  const checkSteps = [
    {
      icon: "🆔",
      title: "Identity Verification",
      description: "Government-issued ID verification and social security number validation.",
    },
    {
      icon: "🔍",
      title: "Criminal Background Check",
      description: "Comprehensive criminal history check at federal, state, and local levels.",
    },
    {
      icon: "📋",
      title: "Professional License Verification",
      description: "Verification of all professional licenses, certifications, and credentials.",
    },
    {
      icon: "📞",
      title: "Reference Checks",
      description: "Professional references from previous employers and colleagues.",
    },
  ];

  return (
    <PageLayout
      title="Background Check Process"
      subtitle="Learn about our comprehensive background check process that ensures patient safety and caregiver quality."
      breadcrumbs={[
        { label: "For Caregivers", href: "/for-caregivers" },
        { label: "Background Check" },
      ]}
    >
      {/* Process Overview */}
      <ContentSection
        title="Our Background Check Process"
        subtitle="Every caregiver undergoes a thorough 4-step verification process to ensure patient safety and quality care."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {checkSteps.map((step, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    fontSize: '3rem',
                    mb: 2,
                  }}
                >
                  {step.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.text.primary,
                  }}
                >
                  {step.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Ready to Get Started?"
        subtitle="Begin your background check process and join our network of verified healthcare professionals."
        primaryButton={{
          text: "Start Application",
          href: "/auth?role=caregiver",
        }}
        secondaryButton={{
          text: "Learn More",
          href: "/become-caregiver",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
